export function getSharedCredentials() {
  const credentials = getSharedCredentialsStorage()

  return {
    login: credentials?.login || '',
    password: credentials?.password || '',
  }
}

export function hasSharedCredentials() {
  const credentials = getSharedCredentialsStorage()

  return credentials?.login && credentials?.password ? true : false
}

export function saveSharedCredentialsStorage(credentials) {
  localStorage.setItem('sharedPanelCredentials', JSON.stringify(credentials))
}

export function getSharedCredentialsStorage() {
  const data = localStorage.getItem('sharedPanelCredentials')
  if (data) {
    try {
      return JSON.parse(data)
    } catch (e) {
      return null
    }
  }
  return null
}

export function clearSharedCredentialsStorage() {
  localStorage.removeItem('sharedPanelCredentials')
}
